var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main",staticStyle:{"background-color":"#f5f5ef"}},[(_vm.loaded)?[_c('div',{staticClass:"column0"},[_c('nav-header')],1),_c('div',{staticClass:"row"},[_c('div',{staticClass:"column1"},[_c('menu-sidebar')],1),_c('div',{staticClass:"column2"},[_c('router-view')],1)])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }